<section class="info-card info-card--tertiary">
    <div class="meta-list">
      <div class="meta-list__item" *ngFor="let item of metaCards()">
        <img src="/public/svgs/{{ item.icon }}.svg" alt="{{ item.icon }}" class="meta-list__icon">
        <span class="meta-list__label">{{ item.labelKey | translate }}</span>
      </div>
    </div>
  </section>